import { ca } from '@cian/analytics';

interface ITrackNewbuildingCarouselChangeParams {
  newbuildings: { id: number }[];
  offerId: number;
  position: number;
  step: number;
}

export const trackNewbuildingCarouselChange = (params: ITrackNewbuildingCarouselChangeParams) => {
  const { offerId, newbuildings, position, step } = params;

  const content = newbuildings
    .slice(position, position + step)
    .map(({ id }, idx) => ({ id, position: position + idx + 1 }));

  ca('eventSite', {
    action: 'click_sopr',
    category: 'Card',
    label: 'scroll_other_JK',
    name: 'oldevent',
    page: {
      extra: {
        is_premium: true,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: { content },
      },
    ],
  });
};
